/**
 * @file Общая панель активных и завершённых передач.
 *
 * Читает состояния обоих Provider. Новая задача или ошибка раскрывает панель;
 * сами процессы передачи выполняются независимо от этой разметки.
 */
import { useEffect, useRef } from 'react'

import DownloadProgress from '../features/downloads/DownloadProgress'
import { downloadMessages } from '../features/downloads/messages'
import { downloadPercent } from '../features/downloads/model'
import { useDownload } from '../features/downloads/useDownload'
import { storageMessages } from '../features/storages/messages'
import UploadProgress from '../features/uploads/UploadProgress'
import { uploadMessages } from '../features/uploads/messages'
import { uploadPercent } from '../features/uploads/model'
import { useUpload } from '../features/uploads/useUpload'
import { useLocale } from '../i18n/useLocale'
import './TaskItem.css'

const TaskList = () => {
    const { locale } = useLocale()
    const { state: upload } = useUpload()
    const { state: download } = useDownload()
    const id = `${upload?.id}:${download?.id}`
    const failed = upload?.phase === 'failed' || download?.phase === 'failed'
    const panel = useRef<HTMLDetailsElement>(null)
    const previousId = useRef<string | undefined>(undefined)

    useEffect(() => {
        if (panel.current && (id !== previousId.current || failed))
            panel.current.open = true

        previousId.current = id
    }, [id, failed])

    return (
        <details className='task-list-container' ref={panel}>
            <summary>
                <span
                    className={`task-summary-status${failed ? ' task-summary-error' : ''}`}
                >
                    {storageMessages[locale].transfers}
                </span>
                {upload && (
                    <span
                        className={`task-summary-file${upload.phase === 'failed' ? ' task-summary-error' : ''}`}
                        title={upload.name}
                    >
                        ↑ {upload.name} · {uploadPercent(upload)}% ·{' '}
                        {uploadMessages[locale].phases[upload.phase]}
                    </span>
                )}
                {download && (
                    <span
                        className={`task-summary-file${download.phase === 'failed' ? ' task-summary-error' : ''}`}
                        title={download.name}
                    >
                        ↓ {download.name} · {downloadPercent(download)}% ·{' '}
                        {downloadMessages[locale].phases[download.phase]}
                    </span>
                )}
            </summary>

            <div className='task-list-body'>
                <UploadProgress />
                <DownloadProgress />
            </div>
        </details>
    )
}

export default TaskList
